import { type ContractRewardType } from '@/common/types/contract';

import cashPng from '/img/icons/cash-large.png';
import cashWebp from '/img/icons/cash-large.webp';
import dicePng from '/img/icons/dice.png';
import diceWebp from '/img/icons/dice.webp';
import starPng from '/img/icons/star-large.png';
import starWebp from '/img/icons/star-large.webp';
import diamondTicketPng from '/img/icons/ticket-diamond.png';
import diamondTicketWebp from '/img/icons/ticket-diamond.webp';
import goldTicketPng from '/img/icons/ticket-gold.png';
import goldTicketWebp from '/img/icons/ticket-gold.webp';
import silverTicketPng from '/img/icons/ticket-silver.png';
import silverTicketWebp from '/img/icons/ticket-silver.webp';

const images: Record<ContractRewardType, { img: string; webp: string }> = {
  cash: {
    img: cashPng,
    webp: cashWebp,
  },
  point: {
    img: starPng,
    webp: starWebp,
  },
  dice: {
    img: dicePng,
    webp: diceWebp,
  },
  silverTicket: {
    img: silverTicketPng,
    webp: silverTicketWebp,
  },
  goldTicket: {
    img: goldTicketPng,
    webp: goldTicketWebp,
  },
  diamondTicket: {
    img: diamondTicketPng,
    webp: diamondTicketWebp,
  },
};

export { images };
